import { render, staticRenderFns } from "./show-guide-tutorial.vue?vue&type=template&id=6d5a65d4"
import script from "./show-guide-tutorial.vue?vue&type=script&lang=js"
export * from "./show-guide-tutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports